<template>
  <div class="step-basic-info-wrapper mt-n8">
    <div class="step-header d-flex align-center justify-space-between mb-4">
      <!-- <h5 class="font-weight-bold mb-0">Basic Information</h5> -->
    </div>
    <v-form v-if="serverData" ref="form" v-model="isFormValid" lazy-validation>
      <v-row class="mt-8">
        <v-col cols="12" sm="6">
          <v-autocomplete
            v-model="formData.action_event"
            :items="serverData.action_events"
            label="Action event"
            item-text="text"
            item-value="index"
            :rules="[(v) => !!v || 'Action event is required']"
            clearable
            outlined
            dense
            @change="$emit('clearAdvancedStepStatusValueOnActionEventChange')"
          />
        </v-col>
        <v-col v-if="showApplyType" cols="12" sm="6">
          <v-autocomplete
            v-model="formData.apply_type_id"
            :items="serverData.apply_types"
            label="Apply Type"
            item-text="text"
            item-value="index"
            :rules="[(v) => !!v || 'Apply Type is required']"
            clearable
            outlined
            dense
          />
        </v-col>
        <v-col
          v-if="serverData.clients"
          cols="12"
          :sm="formData.apply_type_id === 2 ? 12 : 6"
        >
          <v-autocomplete
            v-model="formData.customer_id"
            :items="serverData?.clients"
            label="Customer"
            item-text="text"
            item-value="index"
            :rules="[
              (v) =>
                formData.apply_type_id === 1 && serverData?.clients
                  ? !!v || 'Customer is required'
                  : true,
            ]"
            :multiple="formData.apply_type_id === 2"
            clearable
            outlined
            dense
          />
        </v-col>
        <v-col cols="12" sm="6">
          <v-autocomplete
            v-model="formData.status"
            :items="serverData.status"
            label="Status"
            item-text="text"
            item-value="index"
            :rules="[
              (v) =>
                v !== null && v !== undefined ? true : 'Status is required',
            ]"
            clearable
            outlined
            dense
          />
        </v-col>
        <v-col cols="12" sm="6">
          <v-text-field
            v-model="formData.maximum_retry"
            label="Maximum retry"
            type="number"
            :rules="[
              (v) =>
                (v !== null && v !== '' && v >= 0 && v <= 5) ||
                'Value must be between 0 and 5',
            ]"
            clearable
            outlined
            dense
          />
        </v-col>
        <v-col cols="12" sm="6">
          <v-text-field
            v-model="formData.url"
            label="URL"
            clearable
            outlined
            dense
            :rules="[
              (v) => !!v || 'URL is required',
              (v) =>
                !v ||
                /^https:\/\/.+/i.test(v) ||
                'URL must start with https://',
            ]"
          />
        </v-col>
      </v-row>
      <!-- <div class="d-flex justify-end mt-4">
        <v-btn color="primary" @click="handleNext"> Next </v-btn>
      </div> -->
    </v-form>
  </div>
</template>

<script>
export default {
  name: "StepBasicInfo",
  props: {
    value: Object,
    valid: Boolean,
  },
  data() {
    return {
      formData: { ...(this.value || {}) },
      isFormValid: true,
    };
  },
  watch: {
    value: {
      handler(newVal) {
        // sync incoming prop into local copy for edit mode
        this.formData = { ...(newVal || {}) };
      },
      immediate: true,
      deep: true,
    },
  },
  methods: {
    handleNext() {
      // Validate the form and show all error messages
      this.validateForm();
      // Only proceed if form is valid
      setTimeout(() => {
        if (this.isFormValid) {
          this.$emit("next", { ...this.getFormData() });
        }
      }, 100);
    },
    validateForm() {
      this.$refs.form && this.$refs.form.validate();
      return this.isFormValid;
    },
    getFormData() {
      return { ...(this.formData || {}) };
    },
    reset() {
      this.formData = {
        organization_id: null,
        apply_type_id: null,
        status: null,
        maximum_retry: null,
        action_event: null,
        url: null,
      };
      // reset validation states
      this.$nextTick(() => {
        this.$refs.form && this.$refs.form.resetValidation();
      });
    },
  },
  computed: {
    serverData() {
      return this.$store.getters.getWEBHOOKSActionsDialogServerData;
    },
    showApplyType() {
      return (
        !!this.serverData?.clients?.length &&
        (this.formData.action_event === 3 || this.formData.action_event === 8)
      );
    },
  },
};
</script>
